import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { setCredentials } from "../../stores/authSlice";
import { useAuth } from "../../lib/hooks";

export default function AuthInit() {
    // get the access token from cookie and set that in the user slice
    const [accessToken] = useCookies(["accessToken"]);
    const authenticated = useAuth();
    const dispatch = useDispatch();

    // once a user authenticates update state to reflect that
    if(!authenticated && accessToken.accessToken !== undefined) {
        dispatch(setCredentials(accessToken));
    }

    return <Outlet/>
}